<template>
  <div>
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br/></vs-col>
      </vs-row>
    </template>
    <vx-card title="담당환자 관리" write-toggler @writeClick="popupOpen('', '')">
      <div class="vx-row mb-3">
        <div class="vx-col w-full lg:w-1/1 ">
          <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" v-bind:class="activeMenu(item.MEDICAL_CD)"
                     v-on:click="tabClick(item.MEDICAL_CD)">{{ item.MEDICAL_NM }}
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-3">
        <div class="vx-col w-full lg:w-1/1 ">
          <vs-button type="line" :class="{active: isActive[0]}" @click="tabChange(1)">전체</vs-button>
          <vs-button type="line" :class="{active: isActive[1]}" @click="tabChange(2)">입원</vs-button>
          <vs-button type="line" :class="{active: isActive[2]}" @click="tabChange(3)">최근 외래</vs-button>
          <vs-button type="line" :class="{active: isActive[3]}" @click="tabChange(4)">퇴원 1주 이내</vs-button>
          <vs-button type="line" :class="{active: isActive[4]}" @click="tabChange(5)">재입 2주내 예정</vs-button>
          <vs-button type="line" :class="{active: isActive[5]}" @click="tabChange(6)">VIP</vs-button>
        </div>
      </div>

      <br/><br/>

      <div class="tb_wrap">
        <div class="tb_box" style="width:100%;overflow-x:auto; height:auto;">
          <table id="schedule" style="max-width:2200px; max-height:inherit; width: 100%" class="border-collapse calendar">
            <thead>
            <tr class="fixed_top">
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">구분</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">이름 / 차트번호</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">현재상태</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">다음 입원 예정일</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">마지막 퇴원(예정)일</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">진단명</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">마지막 상담내역의 일자</th>
              <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:120px;">상담내역</th>
            </tr>
            </thead>

            <tbody>
            <template v-if="lists.length == 0">
              <tr>
                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="8">등록된 담당환자가 존재하지 않습니다.</td>
              </tr>
            </template>
            <template v-else>
              <template v-if="this.tabIndex === 1">
                <tr v-for="(item, index) in lists" :key="index">
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                  <td class="p-2 border border-solid d-theme-border-grey-light text-center" style="max-width: 200px">{{ item.CS_CONTENT }}</td>
                </tr>
              </template>

              <template v-if="this.tabIndex === 2">
                <tr v-for="(item, index) in lists" :key="index">
                  <template v-if="item.CD_STATUS === 6">
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_CONTENT }}</td>
                  </template>
                </tr>
              </template>

              <template v-if="this.tabIndex === 3">
                <tr v-for="(item, index) in lists" :key="index">
                  <template v-if="item.CD_STATUS === 8 && new Date() <= new Date(item.IN_DATE).setMonth(new Date(item.IN_DATE).getMonth() + 1)">
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_CONTENT }}</td>
                  </template>
                </tr>
              </template>

              <template v-if="this.tabIndex === 4">
                <tr v-for="(item, index) in lists" :key="index">
                  <template v-if="new Date() <= new Date(item.OUT_DATE) && new Date(item.OUT_DATE) <= new Date().setDate(new Date().getDate() + 7)">
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_CONTENT }}</td>
                  </template>
                </tr>
              </template>

              <template v-if="this.tabIndex === 5">
                <tr v-for="(item, index) in lists" :key="index">
                  <template v-if="item.OUT_DATE && (new Date() <= new Date(item.IN_DATE) && new Date(item.IN_DATE) <= new Date().setDate(new Date().getDate() + 14))">
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_CONTENT }}</td>
                  </template>
                </tr>
              </template>

              <template v-if="this.tabIndex === 6">
                <tr v-for="(item, index) in lists" :key="index">
                  <template v-if="item.PATIENT_POSITION === 2">
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ getCdStatusName(item) }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_USERNAME }} / {{ item.CHART_NO }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.STATUS_NAME }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.IN_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.OUT_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_DATE }}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.CS_CONTENT }}</td>
                  </template>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';

export default {
  components: {
    Datepicker,
    'v-select': vSelect,
  },
  data() {
    return {
      lists: [],
      tab_menu: [],
      isActive: [true, false, false, false, false, false],
      tabIndex: 1,
      medical_cd: '',
      width: window.innerWidth,
    };
  },
  methods: {
    handleResize(event) {
      this.width = window.innerWidth;
    },
    async init(date) {
      const {data} = await axiosClass.get('/api/doctor/patient/list/all', {}, true);

      this.tab_menu = data.tab_menu;
      this.lists = data.lists;
      this.medical_cd = this.tab_menu[0].MEDICAL_CD;

      const test = data.lists.filter(item => item.PATIENT_USERNAME === '오영자');
      console.log(test);
      console.log(new Date() <= new Date(test[0].OUT_DATE) && new Date(test[0].OUT_DATE) <= new Date().setDate(new Date().getDate() + 7));
    },
    activeMenu(medical_code) {
      if (medical_code === this.medical_cd) {
        return 'activeMenu';
      } else {
        return '';
      }
    },
    async tabChange(tabIndex) {
      this.tabIndex = tabIndex;
      this.isActive = [tabIndex === 1, tabIndex === 2, tabIndex === 3, tabIndex === 4, tabIndex === 5, tabIndex === 6];
    },
    getCdStatusName(item) {
      if (item.CD_STATUS === 6) return '입원';
      if (item.CD_STATUS === 8 && new Date() <= new Date(item.IN_DATE).setMonth(new Date(item.IN_DATE).getMonth() + 1)) return '최근 외래';
      if (new Date() <= new Date(item.OUT_DATE) && new Date(item.OUT_DATE) <= new Date().setDate(new Date().getDate() + 7)) return '퇴원 1주 이내';
      if (item.OUT_DATE && (new Date() <= new Date(item.IN_DATE) && new Date(item.IN_DATE) <= new Date().setDate(new Date().getDate() + 14))) return '재입 2주내 예정';
      if (item.PATIENT_POSITION === 2) return 'VIP';
    },
    async tabClick(medical_cd) {
      this.medical_cd = medical_cd;

      this.$vs.loading({
        type: 'default',
        container: '#schedule',
        background: 'rgba(0,0,0,0.1)',
        color: 'primary',
        scale: 1.5,
      });

      const {data} = await axiosClass.get('/api/doctor/patient/list/' + this.medical_cd, {}, true);
      setTimeout(() => {
        this.$vs.loading.close('#schedule > .con-vs-loading');
      }, 100);

      this.lists = data.lists;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    await this.init('');
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);

function reportWindowSize() {

}

</script>

<style>
.calendar tbody tr td {
  padding: 10px;
}

table > thead > tr > th {
  font-weight: 400;
  background-color: blue;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  z-index: 1;
}

table > tbody > tr > td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.tb_box {
  height: 750px;
  overflow: auto;
}

.table_header {
  position: sticky;
  top: 0;
}

html {
  scroll-behavior: smooth;
}

.headerBtn a {
  padding: 5px;
}

.active {
  border-color: #015666;
}

.activeMenu {
  border-color: #015666;
}
.tb_box::-webkit-scrollbar {
  display: none;
}

</style>
